import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M15.606 1.545l-7.21 7.211-2.767-2.768L2.4 9.217v1.697l3.229-3.228 2.767 2.768 7.21-7.211L18 5.635V3.939l-2.394-2.394zM1.2 0H0v18h18v-1.2H1.2V0z" />
  </svg>
);

export default SvgComponent;
